import md5 from 'md5';
import cmp from './cmp';
import dpl from './dpl';
import clearCookies from './clear-cookies';
import eventTracking from './event-tracking';

window.md5 = md5;

cmp.enqueue(
  () => console.log('This code only runs when no CMP needs to load, or when the CMP consent has been accepted. '),
  1
);
cmp.enqueue(() => console.log('This code only runs in GDPR when consent has been rejected.'), 0);

// Clear Cookies when no consent was given
cmp.enqueue(clearCookies, 0);

// CLear local storage when no consent was given
cmp.enqueue(() => {
  window.localStorage.clear();
  console.log('CLEARING LOCAL STORAGE.');
}, 0);

// initialize dpl, except for reviews which loads DPL in the theme.
if (!window.location.host.includes('system1.com')) {
  cmp.enqueue(dpl, 1);
}

window.addEventListener('DOMContentLoaded', () => {
  cmp.enqueue(eventTracking, 1);
});
